import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { useUser } from "../../context/user-context";
import { API } from "../../constants/api";
import { referralLinkFor, referralTweetFor } from "../../constants/links";
import { LuCopy } from "react-icons/lu";
import { AiFillLinkedin } from "react-icons/ai";
import { FaFacebook, FaWhatsappSquare } from "react-icons/fa";
import { AiFillTwitterCircle } from "react-icons/ai";
import CopyToClipboard from "../../components/utils/CopyToClipboard";
import useAuthAxios from "../../utils/baseAxios";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { errorMessage } from "../../utils/errorMessage";
import { getDeviceInfo } from "../../utils/deviceInfo";

const Referral = ({ setOpenRefer }: any) => {
  const { userDetails } = useUser();
  const [screen, setScreen] = useState<boolean>(true);
  const referralcode = userDetails?.user.profile.username
    ? userDetails?.user.profile.username
    : userDetails?.user.referralCode;
  const referralLink = referralLinkFor(referralcode);

  const axiosInstance = useAuthAxios();
  const deviceInfo = getDeviceInfo();

  const trackReferral = async (data: any) => {
    const response = await axiosInstance.post(API.trackEvent, data);
    return response.data;
  };

  // console.log(deviceInfo);
  const completeTrackReferral = useMutation({
    mutationFn: trackReferral,
    onSuccess: (r) => {
      // toast.success(r.message);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const handleTrackReferral = () => {
    const data = {
      event: "REFERRAL__REFERRAL_LINK_COPIED",
      properties: {
        ip: "0.0.0.0",
        platform: "Web",
        deviceInfo: {
          name: deviceInfo.deviceName,
          uniqueId: deviceInfo.uniqueId,
          os: deviceInfo.operatingSystem?.family,
        },
      },
    };
    completeTrackReferral.mutate(data);
  };

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenRefer(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Referral
          </h4>
        </div>
        <div className="mt-8 w-full">
          <div className="w-full bg-referralBg bg-cover bg-center bg-no-repeat p-6 h-[160px] mt-4 rounded-lg">
            <div>
              <h3 className="font-sora font-semibold text-[#2DB7A0] text-[26px]">
                Referral
                <br />
                and Earn!
              </h3>
              <p className="text-gray-400 text-[11px] w-2/3 mt-2">
                Invite your friends and earn points for each friend who signs
                up.
              </p>
            </div>
          </div>
          <h4 className="text-gray-800 dark:text-gray-200 text-[25px] font-sora font-semibold mt-6">
            Get NGN2,000 when you refer a Friend!
          </h4>
          <p className="text-gray-700 dark:text-gray-300 text-[12px] mt-2">
            Copy your referral link and send to your friends and family. Your
            Deex point will be disburse when your friend trades up to $20 on
            their first transaction 🎉.
          </p>

          <div className="w-full flex-col mt-8 justify-center items-center">
            <div className="w-full  flex justify-center items-center ">
              <button
                onClick={() => setScreen(true)}
                className={
                  screen
                    ? "w-1/2 border-b-2 border-secondary_button pb-3 text-secondary_button text-[16px] font-bold"
                    : "w-1/2  pb-3 text-gray-500 font-medium text-[16px]"
                }
              >
                Standard link
              </button>
              <button
                onClick={() => setScreen(false)}
                className={
                  !screen
                    ? "w-1/2 border-b-2 border-secondary_button pb-3 text-secondary_button text-[16px] font-bold"
                    : "w-1/2  pb-3 text-gray-500 font-medium text-[16px]"
                }
              >
                Special link
              </button>
            </div>
            <div className="w-full h-[48px] gap-4 rounded-lg bg-[#E8F3FC] border-[#C6D0D7] mt-4 border text-[#0B75C2]  flex justify-center items-center text-[14px] font-medium ">
              {referralLink}
              <CopyToClipboard text={referralLink} onCopy={handleTrackReferral}>
                <LuCopy className="text-[#0B75C2] text-[18px] " />
              </CopyToClipboard>
            </div>
            <div className="flex justify-center  mt-4  w-full gap-4 mds:gap-2 mx-auto  items-center">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${referralcode}`}
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook className="text-[#06416C] dark:text-secondary_button text-[30px] " />
              </a>
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${referralcode}`}
                target="_blank"
                rel="noreferrer"
              >
                <AiFillLinkedin className="text-[#06416C] dark:text-secondary_button text-[30px] " />
              </a>
              <a
                href={referralTweetFor(referralcode)}
                target="_blank"
                rel="noreferrer"
              >
                <AiFillTwitterCircle className="text-[#06416C] dark:text-secondary_button text-[30px]" />
              </a>
              <a
                href={`https://wa.me/?text=${referralcode}`}
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsappSquare className="text-[#06416C] dark:text-secondary_button text-[30px]" />
              </a>
            </div>
          </div>
          <button
            onClick={() => setOpenRefer(false)}
            className="text-white text-[15px] rounded-xl h-[52px] bg-secondary_button font-medium mt-16 w-full"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default Referral;
